import { Col, Row } from 'antd'
import { Variants, motion } from "framer-motion";
import { FireFilled } from '@ant-design/icons';


const data = [
    {
        title: 'Vòng Sơ Loại: DARE',
        content: {
            time: '06/10/2023 - 31/10/2023',
            prototype: 'Cuộc thi chỉ có 1 format duy nhất là đăng tải video. Các thí sinh đăng ký tham gia và nộp bài dự thi thông qua biểu mẫu được đăng tải trên fanpage và website cuộc thi. Chủ đề dự thi dựa trên theme “Unlock Your Potential”, thí sinh được phép thoải mái sáng tạo dựa trên chủ đề của cuộc thi.',
            method: [
                'Bước 1: Thí sinh cung cấp thông tin được yêu cầu trong biểu mẫu (Mọi sai sót xảy ra bài thi của thí sinh sẽ bị hủy).',
                'Bước 2: Sau khi hoàn thành video, mỗi cá nhân đăng ký dự thi sẽ đăng tải 1 video bài dự thi của mình lên Google Form.',
                'Bước 3: Sau khi hoàn thành việc đăng ký và nộp bài, mẫu mail tự động về câu trả lời form của thí sinh từ Google Form sẽ được gửi vào hòm mail của thí sinh.'
            ]
        },
        requirement: {
            format: 'Video phải được quay với tỉ lệ 16:9 (Ngang), độ phân giải trên tối thiểu 720p - tối đa 1080p, hình ảnh trên video phải rõ ràng, thấy rõ chân dung của thí sinh tham gia dự thi.',
            duration: 'Các video đăng tải không được vượt quá thời lượng 5 phút.',
            content: 'Unlock Your Potential là chủ đề xuyên suốt của cuộc thi. Tuy nhiên các thí sinh tham gia được phép sáng tạo và phát triển nội dung bài nói riêng của mình (không sử dụng quá 70% nội dung khác với chủ đề của cuộc thi). Chủ đề của bài nói được thí sinh phải được phát triển phù hợp tránh các chủ đề về phân biệt sắc tộc, vùng miền, chính trị, tôn giáo và tín ngưỡng.',
            clother: 'Thí sinh xuất hiện trên video phải ăn mặc phù hợp, lịch sự và chỉn chu.'
        }
    },
    {
        title: 'Vòng Bán Kết: SEEK ',
        content: {
            time: '12/11/2023 - 02/12/2023',
            prototype: 'Các bài dự thi xuất sắc vượt qua Vòng Sơ Loại sẽ đủ điều kiện tham gia Vòng Bán Kết.',
            method: [
                'Tất cả các bài thi của Vòng Bán Kết sẽ được thực hiện quay dựng chuyên nghiệp bởi Ban Tổ Chức cuộc thi. Thời gian và địa điểm cụ thể sẽ được gửi vào email của thí sinh. Cách thức tính điểm của Vòng Bán Kết (30% điểm từ khán giả bình chọn, 70% điểm từ giám khảo).'
            ],
        },
        location: 'Tại trường Đại học FPT thành phố Hồ Chí Minh',
    },
    {
        title: 'Vòng Chung Kết: REACH',
        content: {
            time: '10/12/2023',
            prototype: 'Top 10 xuất sắc vượt qua Vòng Bán Kết sẽ tiến vào Vòng Chung Kết.',
            method: [
                '- Vòng thuyết trình dành cho TOP 10',
                '- Vòng ứng biến (bốc thăm keyword) dành cho TOP 5',
            ],
        },
        location: 'Tại trường Đại học FPT thành phố Hồ Chí Minh',
    },
]

type Props = {}

const cardVariants: Variants = {
    offscreen: {
        opacity: 0,
        fontSize: '0rem',
        y: 0,
    },
    onscreen: {
        opacity: 1,
        fontSize: window.innerWidth > 768 ? '3rem' : '2rem',
        y: -100,
        transition: {
            type: 'spring',
            stiffness: 200,
            damping: 20,
        },
    },
};

const LeftVariants: Variants = {
    offscreen: {
        opacity: 0,
        x: -200,
    },
    onscreen: {
        opacity: 1,
        x: 0,
        transition: {
            type: 'spring',
            stiffness: 200,
            damping: 40,
            // duration: 2,
        },

    },
};

const RightVariants: Variants = {
    offscreen: {
        opacity: 0,
        x: 200,
    },
    onscreen: {
        opacity: 1,
        x: 0,
        transition: {
            type: 'spring',
            stiffness: 15,
            damping: 20,
        },
    },
};

export default function Intro2({ }: Props) {
    return (
        <div
            style={{
                color: 'white',
                width: '100%',
            }}
        >
            {/* title */}
            <motion.div
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, amount: 0.8 }}
            >
                <motion.div
                    variants={cardVariants}
                    style={{
                        fontFamily: 'conthrax',
                        textAlign: 'center',
                        height: '10rem',
                    }}>
                    <div>CUỘC THI GỒM</div>
                    <div>3 GIAI ĐOẠN</div>
                </motion.div>
            </motion.div>
            <Row
                justify={'center'}
                style={{
                }}>
                {/* left */}
                <Col>
                    {
                        data.map((item, index) => {
                            return (
                                <motion.div
                                    initial="offscreen"
                                    whileInView="onscreen"
                                    viewport={{ once: false, amount: .2 }}
                                >
                                    <motion.div
                                        variants={LeftVariants}
                                        style={{
                                            fontFamily: 'conthrax',
                                            textAlign: 'center',
                                        }}>
                                        <Card index={index} data={item} />

                                    </motion.div>
                                </motion.div>
                            )
                        })
                    }
                </Col>

                {/* right */}
                {/* <Col>
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: false, amount: 0.3 }}
                        style={{
                            borderRadius: '1rem',
                        }}
                    >
                        <motion.div variants={RightVariants}>
                            <img src='https://pub-d6d2c41035bd487385771fe778786b8a.r2.dev/v2/poster.webp' style={{
                                width: '30rem',
                                borderRadius: '1rem',
                                boxShadow: '0 0 .2rem 0 white',
                            }} />
                        </motion.div>
                    </motion.div>
                </Col> */}

            </Row>
        </div>
    )
}

function Card({ data, index }: { data: any, index: number }) {
    return (
        <div
            className='card-intro2'
            style={{
                fontFamily: 'conthrax',
                boxShadow: '0 0 .1rem 0 white',
                borderRadius: '1rem',
                padding: '1rem',
                height: 'fit-content',
                width: window.innerWidth > 768 ? '40vw' : '80vw',
                marginBottom: '1rem',
                backgroundColor: 'rgba(0, 0, 0, 0.364)',
                color: 'rgba(220, 220, 220, 0.72)',
            }}
        >
            <div style={{
                fontSize: '1.2rem',
                color: 'white',
                marginBottom: '1rem',
                textAlign: 'left'
            }}>
                Giai đoạn {index + 1}
            </div>
            <div style={{
                fontSize: '.8rem',
                color: 'white',
                marginBottom: '1rem',
                textAlign: 'left'
            }}>
                <FireFilled /> {data.title}
            </div>

            <div style={{
                fontFamily: 'Readex Pro',
                fontSize: '.8rem',
                textAlign: 'left',
                lineHeight: '1.5rem',
                fontWeight: 300,
            }}>
                <li><b>Thời gian:</b> {data.content.time}</li>
                <li><b>Hình thức:</b> {data.content.prototype}</li>
                <li><b>Cách thức:</b>
                    {
                        data.content.method.map((item: any) => {
                            return (
                                <div style={{
                                    marginLeft: '1rem',
                                }}>
                                    {item}
                                </div>
                            )
                        })
                    }
                </li>
                {
                    data.location &&
                    <li><b>Địa điểm:</b> {data.location}</li>
                }
                {
                    data.requirement &&
                    <li><b>Yêu cầu:</b> <br />
                        <div style={{
                            marginLeft: '1rem',
                        }}>
                            <div>- Định dạng: {data.requirement.format}</div>
                            <div>- Thời lượng: {data.requirement.duration}</div>
                            <div>- Nội dung: {data.requirement.content}</div>
                            <div>- Trang phục: {data.requirement.clother}</div>
                        </div>
                    </li>
                }
            </div>
        </div>
    )
}